"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateTransitionPicker = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const workflow_1 = require("@sierralabs/workflow");
const StateTransitionPicker = props => {
    const { shape, transition, workflow, onChange } = props;
    const options = workflow.getAllPaths();
    const transitionTarget = (0, workflow_1.createTransitionTarget)(shape, transition.target);
    // value is empty if it's not part of options
    const value = options.includes(transitionTarget) ? transitionTarget : '';
    return (react_1.default.createElement(lab_1.Autocomplete, { disableClearable: true, className: 'field', value: value, options: options, onChange: (_, value) => {
            transition.target = value || '';
            const stateNode = value ? workflow.pathMap.get(value) : undefined;
            onChange === null || onChange === void 0 ? void 0 : onChange(stateNode, transitionTarget, transition);
        }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Transition' }))) }));
};
exports.StateTransitionPicker = StateTransitionPicker;
exports.default = exports.StateTransitionPicker;
//# sourceMappingURL=StateTransitionPicker.js.map